import { getCatalogItemsArgsToParams } from 'data/api/transformers/arguments/get-catalog-items-args-to-params'
import { GetCatalogItemsArgs } from 'types/api/arguments/get-catalog-items-args'
import { GetCatalogItemsResp } from 'types/api/response/get-catalog-items-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getCatalogItems = (args: GetCatalogItemsArgs) =>
  api.get<GetCatalogItemsResp>('/catalog/items', {
    params: {
      ...getCatalogItemsArgsToParams(args),
      search_by_image_uuid: args.searchByImageUuid,
    },
    headers: moneyObjectHeader,
  })
